/*
 * Copyright (c) 2021 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Friday, November 12th 2021, 1:19:29 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import {
  ProcessTemplateArtifact,
  ProcessTemplateArtifactValidationSchema,
  ProcessTemplateArtifactSchemaType,
} from "lib/schemas";
import { WritableModel, WriteOnlyModel } from "lib/schemas/abstract";
import { schemaBuilder } from "lib/validation";

export interface ChoiceOption extends ProcessTemplateArtifact, WritableModel<false> {
  option_label: string;
  option_value: string;
  sequence: number;
  option_group: number;
}

export const ChoiceOptionCodesValidationSchema: ProcessTemplateArtifactSchemaType<WriteOnlyModel<ChoiceOption>> =
  ProcessTemplateArtifactValidationSchema.shape({
    option_label: schemaBuilder.string().required("Kindly provide the label for the option."),
    option_value: schemaBuilder.string().required("Kindly provide the value for the option."),
    sequence: schemaBuilder.number().required("Kindly provide a value for the option."),
    option_group: schemaBuilder.number().required("The option group is a mandatory field."),
  });
